import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StoreHelper } from './store-helper';
import { Store } from './store';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfigService } from './config.service';
import { User } from '../models';
import { IBoundedContext } from '../../config';
import { IUserInfo } from '../models';
import { ManagementService } from './management.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs';

@Injectable()
export class UserService {

    private user: User;
    private _userSubject: BehaviorSubject<User>;
    private _managementCtx: IBoundedContext;

    constructor(
        private _router: Router,
        private _storeHelper: StoreHelper,
        private _api: ApiService,
        private _store: Store,
        private _configService: ConfigService,
        private _managementSvc: ManagementService
    ) {
        this._managementCtx = _configService.getContext('management');
        this._userSubject = new BehaviorSubject<User>(null);
    }

    get user$(): Observable<User> {
        return this._userSubject.asObservable();
    }

    updateUserInfo(): void {
        let that = this;

        this._api.get(this._managementCtx.url, 'users/me')
            .map(userRaw => new User(userRaw))
            .subscribe(user => that._loadUserRegions(user),
                       err => this._handleHttpError(err));
    }

    removeUser() {
        this.user = null;
        this._userSubject.next(this.user);
    }

    inactiveUser() {
        this.user.active = false;
        this._userSubject.next(this.user);
    }

    userHasAccess(err: any) {
        return err.status !== 403;
    }

    private _handleHttpError(err: any) {
       if (err.status === 500 || err.status === 401) {
            this.user = new User(null);
            this.user.isTokenValid = false;
            this._userSubject.next(this.user);
       }
    }

    private _loadUserRegions(user: IUserInfo) {
        let that = this;
        that.user = user;

        this._managementSvc.loadRegions(user)
            .subscribe(regions => {
                that.user.regions = regions;
                that.user.locations = regions.map(r => r.locations).reduce((l, l2) => l.concat(l2));
                that._userSubject.next(that.user);
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/user.service.ts